import { type FunctionComponent } from 'react';
import { PAGE_CONTENT_STYLE } from '../../../constants/general';
import { SUPPORT_EMAIL_US_LINK } from '../../../constants/links';
import { useContactInfo } from '../../../hooks/apollo/site/site.hooks';
import { DyRecommendationContextType, useDyRecommendationContext } from '../../../hooks/dynamic-yield/dynamic-yield-client.hooks';
import { StyledLink } from '../../common-components/link/styled-link.component';
import { DynamicYieldPlacement } from '../../dynamic-yield/placement/dynamic-yield-placement.component';
import { Status } from '../../status';

export const ProductNotFound: FunctionComponent = () => {
	const {
		phone: { number: phoneNumber }
	} = useContactInfo();
	useDyRecommendationContext({ type: DyRecommendationContextType.OTHER_PAGE, data: ['404'] });

	return (
		<Status code={404}>
			<div className={PAGE_CONTENT_STYLE} data-testid={'product-404-content'}>
				<h1>Thank you for shopping at Ferguson Home</h1>
				<p>
					The product you requested from our site could not be found or has been discontinued. If you're sure the product exists,
					please call our <StyledLink url={SUPPORT_EMAIL_US_LINK}>customer service</StyledLink> center at{' '}
					<span>{phoneNumber}</span> to see if we can add it while you're browsing our site.
				</p>
				<h2>Need help?</h2>
				<ul>
					<li>
						<StyledLink url={SUPPORT_EMAIL_US_LINK}>Email Us</StyledLink>
					</li>
					<li className="mt2">
						Call <span>{phoneNumber}</span>
					</li>
				</ul>
				<DynamicYieldPlacement dynamicYieldId="dy-recs-error-page-1" />
			</div>
		</Status>
	);
};
